import { observer } from "mobx-react";
import { PriceFormats, SummaryColumns } from "@repo/utils";
import { useEstimateStructure, ValueCell } from "@tools";

export const MaterialsCompanyCostCell = observer((cellProps) => {
  const structure = useEstimateStructure();
  const { settings } = structure;
  const { currencyObj, companyBreakdownMaterialCost, priceFormat } = settings;
  
  const handleCostChange = (v) =>
    settings.setCompanyBreakdownMaterialCost(v);
  
  return <ValueCell
    colName={ SummaryColumns.C_COST }
    useDynamicWidth
    fullWidthInputs
    displayContent
    editable
    value={companyBreakdownMaterialCost}
    onValueChange={handleCostChange}
    symbolStart={currencyObj.symbolStart}
    symbolEnd={currencyObj.symbolEnd}
    americanFormat={priceFormat === PriceFormats.AMERICAN}
    applySuffixSpacing
    max={10000000}
    {...cellProps}
  />
})